module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/shoals.bc3c352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/shoals.jpg
// module id = Yg+I
// module chunks = 0